/* eslint-disable */
import React from "react";
import { IconButton, Tooltip, Box } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";

const RefreshAndFullscreenActions = ({
  onRefresh,
  onToggleFullscreen,
  isFullscreen,
  iconDisabled = false,
}) => {
  const navy = "#16325C";

  return (
    <>
      <Box
        sx={{
          bgcolor: "white",
          border: "1px solid #e0e0e0",
          borderRadius: "19px",
          /* no explicit padding = tall container */
          // either control via padding:
          py: 0.25, // 2px top & bottom
          px: 1, // 8px left & right
          // or hard‐code a height:
          height: 35, // 40px total
          display: "flex",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <Tooltip title="Reload data" arrow>
          <IconButton
            onClick={onRefresh}
            disabled={iconDisabled}
            sx={{ color: navy }}
          >
            <RefreshIcon sx={{ fontSize: 24 }} />
          </IconButton>
        </Tooltip>
        <Tooltip
          title={isFullscreen ? "Exit full screen" : "Full screen"}
          arrow
        >
          <IconButton onClick={onToggleFullscreen} sx={{ color: navy }}>
            {isFullscreen ? (
              <FullscreenExitIcon sx={{ fontSize: 24 }} />
            ) : (
              <FullscreenIcon sx={{ fontSize: 24 }} />
            )}
          </IconButton>
        </Tooltip>
      </Box>
    </>
  );
};

export default RefreshAndFullscreenActions;
